export default "__VITE_ASSET__9f43b388__"